import * as types from "../../constants/actionTypes";

const initState = {
    isLoading: false,
    listReservasiResepObat:[],
    formDetailResepObat: {
        detailReservasi: {
            f_nama_pasien: "",
            f_no_identitas: "",
            f_nama_dokter: "",
            f_nama_poliklinik: ""
        },
        listResepObat: []
    }
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.DASHBOARD_APOTEK_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_ALL_SUCCESS: {
            return {
                ...state,
                listReservasiResepObat : action.value
            }
        }

        case types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_DETAIL_SUCCESS: {
            return {
                ...state,
                formDetailResepObat : action.value
            }
        }
        default:
            return {
                ...state
            }
    }
}  